import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UserAddPlusSvg = function UserAddPlusSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7.485 3.596a4.598 4.598 0 1 1 6.502 6.502 4.598 4.598 0 0 1-6.502-6.502m3.25.032a3.218 3.218 0 1 0 0 6.437 3.218 3.218 0 0 0 0-6.437",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M3.38 15.948v1.474h8.505V18.8H2v-3.67l.354-.197a16.7 16.7 0 0 1 8.152-2.11c1.665 0 3.275.242 4.794.695l-.394 1.322a15.4 15.4 0 0 0-4.4-.638h-.001a15.3 15.3 0 0 0-7.126 1.745M17.172 13.973v3.448h-3.448v1.38h3.448v3.448h1.38v-3.448H22v-1.38h-3.448v-3.448z"
    })]
  });
};
export var UserAddPlus = function UserAddPlus(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: UserAddPlusSvg
  }));
};